import { z } from 'zod';
import { requiredString } from '../helpers';
export const Document_Generate_PDF_1_ConfigValidator = z
    .object({
    mode: z.enum(['generate', 'edit']),
    prompt: requiredString('Prompt is required'),
    fileName: requiredString('File name is required'),
    sourceFilePath: z.string().optional()
})
    .refine((data) => data.mode !== 'edit' || (data.sourceFilePath && data.sourceFilePath.length > 0), {
    path: ['sourceFilePath'],
    message: 'Source file path is required for edit mode'
});
//# sourceMappingURL=document-generate-pdf-1.js.map